(function(){
  function moneyCents(text){
    let value=text.replace(/[^0-9.,-]/g,'');
    if(!value)return NaN;
    const separator=Math.max(value.lastIndexOf('.'),value.lastIndexOf(','));
    const decimal=separator>=0&&value.length-separator-1===2;
    const fraction=decimal?value.slice(separator+1):'00';
    const whole=(decimal?value.slice(0,separator):value).replace(/[.,]/g,'');
    return Math.round(Number(whole)*100+Number(fraction));
  }
  function init(){
    const config=document.querySelector('[data-bm-compare-savings-script]');
    if(!config)return;
    const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:config.dataset.currency||'USD',minimumFractionDigits:2,maximumFractionDigits:2});
    document.querySelectorAll('[data-price-wrapper]').forEach(function(wrapper){
      const price=wrapper.querySelector('[data-product-price]');
      const compare=wrapper.querySelector('[data-product-compare-price]');
      if(!price||!compare||wrapper.querySelector('.bm-purchase-promo-price')||wrapper.querySelector('[data-bm-compare-savings]'))return;
      const badge=document.createElement('span');
      badge.className='bm-compare-savings';
      badge.setAttribute('data-bm-compare-savings','');
      badge.hidden=true;
      compare.insertAdjacentElement('afterend',badge);
      function update(){
        const savings=moneyCents(compare.textContent)-moneyCents(price.textContent);
        const visible=Number.isFinite(savings)&&savings>0&&!compare.hidden&&window.getComputedStyle(compare).display!=='none';
        badge.hidden=!visible;
        wrapper.classList.toggle('bm-compare-price-row',visible);
        if(visible)badge.textContent=(config.dataset.savingsLabel||'SAVE')+' '+formatter.format(savings/100);
      }
      update();
      const observer=new MutationObserver(update);
      const options={childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style','class','hidden']};
      observer.observe(price,options);
      observer.observe(compare,options);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
